import React from 'react';
import { CheckCircle } from 'lucide-react';

const Services = () => {
  return (
    <section className="py-16 bg-white" id="services">
      <div className="max-w-6xl mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold mb-4 text-gray-900">
            Services We <span className="text-sky-600">Offer</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Customized solutions to help you achieve your fitness goals
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {/* Service 1 */}
          <div className="bg-sky-50 rounded-xl p-8 shadow-sm hover:shadow-md transition duration-300 flex flex-col h-full">
            <h3 className="text-2xl font-bold mb-6 text-sky-600">Online Fitness and Nutrition Coaching</h3>
            <p className="text-gray-700 mb-6">
              We offer customized training and nutritional plans that can help you to reach your fitness goals
            </p>
            
            <h4 className="font-bold text-gray-900 mb-4">What's included:</h4>
            <ul className="space-y-3 mb-8 flex-grow">
              <li className="flex items-start gap-3">
                <div className="flex-shrink-0 mt-1 text-sky-600">
                  <CheckCircle size={20} />
                </div>
                <p className="text-gray-700">Individualized workout plan</p>
              </li>
              <li className="flex items-start gap-3">
                <div className="flex-shrink-0 mt-1 text-sky-600">
                  <CheckCircle size={20} />
                </div>
                <p className="text-gray-700">Regular check-ins to ensure you're on track</p>
              </li>
              <li className="flex items-start gap-3">
                <div className="flex-shrink-0 mt-1 text-sky-600">
                  <CheckCircle size={20} />
                </div>
                <p className="text-gray-700">Weekly nutrition coaching</p>
              </li>
              <li className="flex items-start gap-3">
                <div className="flex-shrink-0 mt-1 text-sky-600">
                  <CheckCircle size={20} />
                </div>
                <p className="text-gray-700">Adjustments based on your progress</p>
              </li>
              <li className="flex items-start gap-3">
                <div className="flex-shrink-0 mt-1 text-sky-600">
                  <CheckCircle size={20} />
                </div>
                <p className="text-gray-700">24/7 text support and accountability coaching</p>
              </li>
              <li className="flex items-start gap-3">
                <div className="flex-shrink-0 mt-1 text-sky-600">
                  <CheckCircle size={20} />
                </div>
                <p className="text-gray-700">Full access to our fitness app</p>
              </li>
              <li className="flex items-start gap-3">
                <div className="flex-shrink-0 mt-1 text-sky-600">
                  <CheckCircle size={20} />
                </div>
                <p className="text-gray-700">Mobility assessments</p>
              </li>
              <li className="flex items-start gap-3">
                <div className="flex-shrink-0 mt-1 text-sky-600">
                  <CheckCircle size={20} />
                </div>
                <p className="text-gray-700">Injury and rehab consultation</p>
              </li>
            </ul>
            
            <div className="mt-auto">
              <a
                href="#packages"
                className="inline-block w-full text-center bg-sky-600 text-white text-lg px-6 py-4 rounded-xl hover:bg-sky-700 transition duration-300 shadow-lg"
              >
                Get Pricing Info
              </a>
            </div>
          </div>

          {/* Service 2 */}
          <div className="bg-sky-50 rounded-xl p-8 shadow-sm hover:shadow-md transition duration-300 flex flex-col h-full">
            <h3 className="text-2xl font-bold mb-6 text-sky-600">VIP In-Person Coaching</h3>
            <p className="text-gray-700 mb-6">
              We offer hybrid coaching where we work with you as an in-person trainer and as a coach outside of the gym
            </p>
            
            <h4 className="font-bold text-gray-900 mb-4">What's included:</h4>
            <ul className="space-y-3 mb-8 flex-grow">
              <li className="flex items-start gap-3">
                <div className="flex-shrink-0 mt-1 text-sky-600">
                  <CheckCircle size={20} />
                </div>
                <p className="text-gray-700">In-person coaching sessions</p>
              </li>
              <li className="flex items-start gap-3">
                <div className="flex-shrink-0 mt-1 text-sky-600">
                  <CheckCircle size={20} />
                </div>
                <p className="text-gray-700">Individualized workout plan</p>
              </li>
              <li className="flex items-start gap-3">
                <div className="flex-shrink-0 mt-1 text-sky-600">
                  <CheckCircle size={20} />
                </div>
                <p className="text-gray-700">Regular check-ins to ensure you're on track</p>
              </li>
              <li className="flex items-start gap-3">
                <div className="flex-shrink-0 mt-1 text-sky-600">
                  <CheckCircle size={20} />
                </div>
                <p className="text-gray-700">Weekly nutrition coaching</p>
              </li>
              <li className="flex items-start gap-3">
                <div className="flex-shrink-0 mt-1 text-sky-600">
                  <CheckCircle size={20} />
                </div>
                <p className="text-gray-700">Adjustments based on your progress</p>
              </li>
              <li className="flex items-start gap-3">
                <div className="flex-shrink-0 mt-1 text-sky-600">
                  <CheckCircle size={20} />
                </div>
                <p className="text-gray-700">24/7 text support and accountability coaching</p>
              </li>
              <li className="flex items-start gap-3">
                <div className="flex-shrink-0 mt-1 text-sky-600">
                  <CheckCircle size={20} />
                </div>
                <p className="text-gray-700">Full access to our fitness app</p>
              </li>
              <li className="flex items-start gap-3">
                <div className="flex-shrink-0 mt-1 text-sky-600">
                  <CheckCircle size={20} />
                </div>
                <p className="text-gray-700">Mobility assessments</p>
              </li>
              <li className="flex items-start gap-3">
                <div className="flex-shrink-0 mt-1 text-sky-600">
                  <CheckCircle size={20} />
                </div>
                <p className="text-gray-700">Injury and rehab consultation</p>
              </li>
            </ul>
            
            <div className="mt-auto">
              <a
                href="#packages"
                className="inline-block w-full text-center bg-sky-600 text-white text-lg px-6 py-4 rounded-xl hover:bg-sky-700 transition duration-300 shadow-lg"
              >
                Get Pricing Info
              </a>
            </div>
          </div>
        </div>

        <div className="mt-16 text-center bg-sky-100 p-8 rounded-xl">
          <blockquote className="text-2xl italic text-gray-700 mb-6">
            "Olu is the first trainer that understood my personal condition (scoliosis & diastasis recti) and he took on the challenge to help me achieve my personal goals of getting fit and eating healthier."
          </blockquote>
          <div className="text-sky-600 font-bold">- Satisfied Client</div>
        </div>
      </div>
    </section>
  );
};

export default Services;